import { useOutletContext } from "react-router-dom";
import type { BreadcrumbEntityCache } from "@ilabel/ui";
import type { PageResourceClient } from "./page-resource-client.js";

export const APP_SESSION_QUERY_KEY = ["app-shell", "session"] as const;

export interface AppSessionData {
  readonly account?: {
    readonly id?: string | number;
    readonly name?: string;
    readonly username?: string;
    readonly shouldRemindInitialPassword?: boolean;
    readonly teamIds?: readonly (string | number)[];
  };
  readonly roles?: readonly string[];
  readonly permissions?: readonly string[];
  readonly projectIds?: readonly (string | number)[];
  readonly managedProjectIds?: readonly (string | number)[];
  readonly csrfToken?: string;
  readonly initialPasswordReminderSessionKey?: string;
  readonly defaultRoute?: string;
}

export interface AppSessionContextValue {
  readonly resources?: PageResourceClient;
  readonly breadcrumbEntities?: BreadcrumbEntityCache;
  readonly session: AppSessionData | null;
  readonly sessionPending: boolean;
  readonly sessionError: unknown;
  readonly revalidateSession: () => Promise<AppSessionData | null>;
}

export function useAppSession() {
  return useOutletContext<AppSessionContextValue>();
}
